import HttpService from '@/common/services/HttpService'
import type { SpaceDTO } from '@/common/types/spaces'

export const getSpaces = async (): Promise<SpaceDTO[]> => {
  return HttpService.getData<SpaceDTO[]>('/api/v2/spaces')
}

export const getSpaceByCode = async (code: UUID): Promise<SpaceDTO> => {
  return HttpService.getData<SpaceDTO>(`/api/v1/spaces/${code}`)
}
